var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.293 0.292786C13.4805 0.105315 13.7348 0 14 0C14.2652 0 14.5195 0.105315 14.707 0.292786L18.707 4.29279C18.8945 4.48031 18.9998 4.73462 18.9998 4.99979C18.9998 5.26495 18.8945 5.51926 18.707 5.70679L5.707 18.7068C5.51951 18.8943 5.26519 18.9997 5 18.9998H1C0.734784 18.9998 0.48043 18.8944 0.292893 18.7069C0.105357 18.5194 0 18.265 0 17.9998V13.9998C5.66374e-05 13.7346 0.105451 13.4803 0.293 13.2928L10.293 3.29279L13.293 0.292786ZM11 5.41379L2 14.4138V16.9998H4.586L13.586 7.99979L11 5.41379ZM15 6.58579L16.586 4.99979L14 2.41379L12.414 3.99979L15 6.58579Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d7898b9f43b4253f99ea6fa1be4c8850.svg";
export { ForwardRef as ReactComponent };